"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Trials = require("self-service-api/constants/Trials");

var _TrialActivationButton = _interopRequireDefault(require("ui-addon-upgrades/_core/trial/TrialActivationButton"));

var updateUpgradeData = function updateUpgradeData(props) {
  return (0, _extends2.default)({}, props, {
    upgradeData: (0, _extends2.default)({}, props.upgradeData, {
      source: props.upgradeData.app + "-" + props.upgradeData.screen + "-trial-button-" + props.upgradeData.uniqueId,
      trialId: _Trials.upgradeProductToTrialIds[props.upgradeData.upgradeProduct] || null
    })
  });
};

var UITrialActivationButton = function UITrialActivationButton(props) {
  return _react.default.createElement(_TrialActivationButton.default, updateUpgradeData(props));
};

var _default = UITrialActivationButton;
exports.default = _default;
module.exports = exports.default;